import Image from "next/image";


export const HeaderBannerWithImage = ({bannerImageUrl}) => {
  return (
    <div className="py-[50px] ">
        <Image src={bannerImageUrl} alt="banner" width={1000} height={1000} className="w-full h-full object-contain" />
    </div>
  );
};
